import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Store } from '../../store';
import { Spin, Button, Card, message, Tooltip } from 'antd';
import { CloseCircleFilled, HeartFilled, HeartOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { REMOVE_FAVOURITE, GET_FAVOURITES, ADD_TO_CARD } from '../../constants/actions';
import App from '../../components/App';
import { NotificationManager } from 'react-notifications';
import { HOME } from '../../constants/routes';
import './style.scss';

const { Meta } = Card;

const Favourites = () => {
  const { state, dispatch } = useContext(Store);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('email')) {
      axios.post('https://api-appnytimes.herokuapp.com/book/get-favourites', {
        "email": localStorage.getItem('email')
      }).then(response => {
        if (response.data.status) {
          dispatch({
            type: GET_FAVOURITES,
            payload: response.data.favourites
          })
        }
      }).catch(error => {
        message.warn(error);
      })
      setIsActive(false);
    }
  }, [])

  function deleteBookFromFavourites(value) {
    setIsActive(true);
    value.is_favourite = false;

    dispatch({
      type: REMOVE_FAVOURITE,
      payload: value
    });

    if (localStorage.getItem('email')) {
      axios.delete('https://api-appnytimes.herokuapp.com/book/favourites/delete', {
        data: {
          email: localStorage.getItem('email'),
          primary_isbn10: value.primary_isbn10
        }
      })
        .then(response => {
          if (response.status === 200) {
            NotificationManager.success(`Book was deleted successfully`, 'Success');
          }
          // message.success(response);
        })
        .catch(error => {
          message.warn(error);
          // console.log(error);
        })
    }

    setTimeout(() => {
      setIsActive(false);
    }, 500);
  }

  function addToCart(value) {
    setIsActive(true);
    const index = state.addedItems.findIndex(el => el.primary_isbn10 == value.primary_isbn10);
    if (index === -1) {
      let price = Number((Math.random() * (30 - 10) + 10).toFixed(2));
      let orderCount = 1;
      value["book_price"] = price;
      value["total_book_price"] = price;
      value["order_count"] = orderCount;

      dispatch({
        type: ADD_TO_CARD,
        payload: value
      });

      if (localStorage.getItem('email')) {
        axios.post('https://api-appnytimes.herokuapp.com/book/add-to-cart', {
          "email": localStorage.getItem('email'),
          "primary_isbn10": value.primary_isbn10,
          "primary_isbn13": value.primary_isbn13,
          "publisher": value.publisher,
          "description": value.description,
          "title": value.title,
          "author": value.author,
          "contributor": value.contributor,
          "book_image": value.book_image,
          "buy_links": value.buy_links,
          "book_price": value.book_price,
          "total_book_price": value.total_book_price,
          "order_count": value.order_count
        })
          .then(response => {
            NotificationManager.success(`Book was added successfully`, 'Success');
            // console.log(response);
          })
          .catch(error => {
            NotificationManager.error('Something went wrong!', 'Error');
          })
      }
      setTimeout(() => {
        setIsActive(false);
      }, 500);
    } else {
      NotificationManager.warning('This book already exists in your cart', 'Warning');
      setIsActive(false);
    }
  }

  return (
    <App>
      <div className="favourites-component">
        <Spin spinning={isActive} size="large" style={{ height: '100vh', maxHeight: 'none' }}>
          <h3 className="page-title">My Favourites</h3>
          {
            state.favourites.length > 0 ?
              <div className="favourites-area">
                {
                  state.favourites.map((favourite, index) => {
                    return (
                      <Card
                        key={index}
                        style={{ width: 220 }}
                        cover={
                          <img
                            className="book-image"
                            alt="example"
                            src={favourite.book_image}
                          />
                        }
                        actions={[
                          <ShoppingCartOutlined className="add-to-cart" key="basket" title="Add To Cart" onClick={() => addToCart(favourite)}/>,
                          <HeartFilled key="favourite" style={{color: '#f28232'}} />,
                          <CloseCircleFilled className="delete-icon" key="remove" title="Delete" onClick={() => deleteBookFromFavourites(favourite)}/>
                        ]}
                      >
                        <Meta
                          title={
                            <Tooltip placement="topLeft" title={favourite.title}>
                              {favourite.title}
                            </Tooltip>
                          }
                          description={
                            <Tooltip placement="topLeft" title={favourite.contributor}>
                              {favourite.contributor}
                            </Tooltip>
                          }
                        />
                      </Card>
                    )
                  })
                }
              </div>
              :
              <div className="empty-favourites">
                <HeartOutlined className="heart-icon" />
                <span className="info">Your favourite list is empty</span>
                <Link to={HOME}>
                  <Button className="btn-view-books">View Books</Button>
                </Link>
              </div>
          }
        </Spin>
      </div>
    </App>
  )
}

{/* <div key={index} className="favourite-book">
  <img className="book-image" src={`${favourite.book_image}`} />
  <CloseCircleFilled className="delete-icon" onClick={() => deleteBookFromFavourites(favourite)} />
  <span className="title">{favourite.title}</span>
  <span className="author">{favourite.contributor}</span>
  <button className="add-to-cart" onClick={() => addToCart(favourite)}>Add To Cart</button>
</div> */}

export default Favourites;